import React, { useEffect, useState, useRef, useContext } from "react";
import { Redirect, useHistory } from "react-router-dom";
import { URLBunge } from "./Componentes/Config";
import { LogAcesso, ReactHtmlParser } from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";

import {
  Clear,
  BackgroundImg,
  LogoMinhaBunge,
  ColunaRegras,
  TitRegrasPontuacao,
  StyledForm,
  TituloMensagem,
  AreaHome,
} from "./Estilos";

import BgRegras from "./Images/BgBunge.jpg";
import ImgLogoMinhaBunge from "./Images/LogoMinhaBunge.png";

function PremioFeira(props) {
  const [Loading, setLoading] = useState(true);
  const [mensagem, setMensagem] = useState("");
  const [cpf, setCpf] = useState(
    document.location.pathname.substr(1).split("/")[1]
  );

  async function PegaMensagemPremio() {
    var requestOptions = { method: "GET", redirect: "follow" };

    fetch(`${URLBunge}/api/Jogo/LerQRCode/${cpf}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.sucesso === false) {
          setMensagem("Ops! Este usuário já resgatou o prêmio!")
        } else {
          setMensagem("Este usuário está apto à resgatar o prêmio!")
        }

        setLoading(false);
      })
      .catch((error) => console.log("error", error));
  }

  useEffect(() => {
    PegaMensagemPremio();
  }, []);

  return (
    <>
      <CabecalhoPagina />
      {Loading === true ? <Carregando /> : null}

      <BackgroundImg
        Background={BgRegras}
        BackgroundMob={BgRegras}
        bgcolor={"#3c647d"}
      >
        <ColunaRegras>
          <div className={"AreaColunaRegras"}>
            <LogoMinhaBunge src={ImgLogoMinhaBunge} MaxWidth={"200px"} />
            <Clear />

            <TitRegrasPontuacao>Prêmio Feira FIPAN</TitRegrasPontuacao>
            <AreaHome>
              <StyledForm>
                <TituloMensagem>{mensagem}</TituloMensagem>
              </StyledForm>
            </AreaHome>
          </div>
        </ColunaRegras>
      </BackgroundImg>
    </>
  );
}

export default PremioFeira;
